export default __webpack_public_path__ + "d5ea778e694a1303a7b65719c667fbb9.png";